import apiClient from './client';

// Function to get field officer report data
export const getFieldOfficerReportData = async ({
  apiPath,
  cursor,
  limit,
  tenant,
  filter
}) => {
  const url = `digitization/v1/field_officer/report`;

  const data = await apiClient.post(url, {
    cursor,
    limit,
    filters: filter
  });
  return data;
};

// API functions for field officer
export const fieldOfficerReportApi = {
  // Fetch dynamic form for field officer creation
  getFieldOfficerForm: tenantId =>
    apiClient.get(`/digitization/v1/field_officer/form?is_edit=false`),

  // Fetch form to edit field officer
  getEditFieldOfficerForm: (tenantId, fieldOfficerId) =>
    apiClient.get(
      `/digitization/v1/field_officer/form?field_officer_id=${fieldOfficerId}&is_edit=true`
    ),

  // Submit a new field officer
  submitFieldOfficer: (tenantId, data) =>
    apiClient.post(`/digitization/v1/field_officer`, data),

  submitEditFieldOfficer: (tenantId, fieldOfficerId, data) =>
    apiClient.put(`/digitization/v1/field_officer/${fieldOfficerId}`, data),

  fieldOfferChart: () =>
    apiClient.get(`/digitization/v1/field_officer/farmer/chart`)
};
